var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "indicator__page__view" }, [
      _c("div", { staticClass: "bar-loading-5" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }